var binds = { vm: '=' };
var ReportGeneralController = (function () {
    function ReportGeneralController() {
        this.visible = false;
    }
    ReportGeneralController.prototype.toggle = function () {
        if (this.visible) {
            this.visible = false;
        }
        else {
            this.visible = true;
        }
    };
    return ReportGeneralController;
}());
var ReportGeneralComponent = (function () {
    function ReportGeneralComponent() {
        this.templateUrl = 'report-general.html';
        this.bindings = binds;
        this.controller = ReportGeneralController;
    }
    return ReportGeneralComponent;
}());
angular
    .module('application')
    .component('reportGeneral', new ReportGeneralComponent());

//# sourceMappingURL=report-general.component.js.map
